// *******************************************************************************
// Cookie Banner
// *******************************************************************************

const cookieElement = document.querySelector('.cookie-banner');

if (cookieElement) {
  if (!Cookies.get('performance_cookie')) {
    cookieElement.classList.add('cookie-not-set');
  }

  // *******************************************************************************
  // Close Banner When Escape Key Press
  // *******************************************************************************

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      cookieElement.classList.remove('cookie-not-set');
    }
  });

  // *******************************************************************************
  // Close Banner When Click Outside
  // *******************************************************************************

  document.addEventListener('click', (event) => {
    if (!cookieElement.contains(event.target)) {
      cookieElement.classList.remove('cookie-not-set');
    }
  });
}
